import { defineComponent, Transition, createVNode } from 'vue';
import { useRoute, RouterView } from 'vue-router';
import { Layout } from 'ant-design-vue';
import { getPrefixCls, getPropSlot } from '../_utils/props-tools';
import PropTypes from '../_utils/props-types';
import MiRouteHistory from '../history';
import MiLayoutFooter from './footer';
export default defineComponent({
    name: 'MiLayoutContent',
    inheritAttrs: false,
    props: {
        prefixCls: PropTypes.string,
        animation: PropTypes.string.def('page-slide'),
        showRouteHistory: PropTypes.bool.def(true),
        footer: PropTypes.any
    },
    setup(props, { slots }) {
        const prefixCls = getPrefixCls('layout-content', props.prefixCls);
        const animation = getPrefixCls(`anim-${props.animation}`);
        const route = useRoute();
        return () => (<Layout.Content class={prefixCls}>
                {props.showRouteHistory ? <MiRouteHistory /> : null}
                <div class={`${prefixCls}-drop`}></div>
                <RouterView v-slots={{
                default: ({ Component }) => {
                    return (<Transition name={animation} appear={true}>
                                    <div class={`${prefixCls}-custom`} key={route.name}>
                                        {createVNode(Component)}
                                        {getPropSlot(slots, props, 'footer') ?? <MiLayoutFooter />}
                                    </div>
                                </Transition>);
                }
            }}/>
            </Layout.Content>);
    }
});
